import { MasarRolesEnum, RolesTypeEnum } from '../model/roles';

export function _hasMasarRole(rolesArray: any[]): boolean {
  return rolesArray.some((role) =>
    Object.values(MasarRolesEnum).includes(role?.replace('ROLE_', ''))
  );
}

export function _getAccountRolesType(rolesArray: any[]): RolesTypeEnum {
  return _hasMasarRole(rolesArray) ? RolesTypeEnum.MASAR : RolesTypeEnum.ITIMAD;
}
